module.exports = __webpack_public_path__ + "static/img/pbrand2.28d4954b.png";